
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1208"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1208",
    "ar-eg": "static-7.1208",
    "bg": "static-7.1208",
    "bn": "static-7.1208",
    "ca-es": "static-7.1208",
    "cs": "static-7.1208",
    "da": "static-7.1208",
    "de": "static-7.1208",
    "el": "static-7.1208",
    "en-gb": "static-7.1208",
    "en": "static-7.1208",
    "es-mx": "static-7.1208",
    "es": "static-7.1208",
    "et": "static-7.1208",
    "fi": "static-7.1208",
    "fr-ca": "static-7.1208",
    "fr": "static-7.1208",
    "he-il": "static-7.1208",
    "hi": "static-7.1208",
    "hr": "static-7.1208",
    "hu": "static-7.1208",
    "id": "static-7.1208",
    "it": "static-7.1208",
    "ja": "static-7.1208",
    "ko": "static-7.1208",
    "lt": "static-7.1208",
    "ms": "static-7.1208",
    "nl": "static-7.1208",
    "no": "static-7.1208",
    "pl": "static-7.1208",
    "pt-br": "static-7.1208",
    "pt-pt": "static-7.1208",
    "ro": "static-7.1208",
    "ru": "static-7.1208",
    "sk": "static-7.1208",
    "sl": "static-7.1208",
    "sv": "static-7.1208",
    "th": "static-7.1208",
    "tl": "static-7.1208",
    "tr": "static-7.1208",
    "uk": "static-7.1208",
    "vi": "static-7.1208",
    "x-pseudo": "static-7.1208",
    "zh-cn": "static-7.1208",
    "zh-hk": "static-7.1208",
    "zh-tw": "static-7.1208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1208'}); }
})();


